import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { useLocalization } from '@ui-framework/index';
import { getMonth } from './constants';

function getPeriodLabel({ cursor, endCursor, formatMessage }) {
  const startMonthName = getMonth({
    formatMessage,
    number: 1 + cursor.month(),
  })?.shortLabel;
  const endMonthName = getMonth({
    formatMessage,
    number: 1 + endCursor.month(),
  })?.shortLabel;
  const startDay = cursor.format('D');
  const endDay = endCursor.format('D');
  const startYear = cursor.format('YYYY');
  const endYear = endCursor.format('YYYY');

  if (cursor.isSame(endCursor, 'day')) {
    return `${startMonthName} ${startDay}, ${startYear}`;
  }
  if (startYear === endYear) {
    return `${startMonthName} ${startDay} – ${endMonthName} ${endDay}, ${startYear}`;
  }
  return `${startMonthName} ${startDay}, ${startYear} – ${endMonthName} ${endDay}, ${endYear}`;
}

function PeriodNavigator({ hidePrev, goPrev, cursor, goNext, endCursor }) {
  const { formatMessage } = useLocalization();
  const label = getPeriodLabel({ cursor, endCursor, formatMessage });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        flexWrap: 'wrap',
      }}>
      {!hidePrev ? (
        <Tooltip
          arrow
          placement="top"
          title={
            <FormattedMessage
              id="PREVIOUS_PERIOD"
              defaultMessage="Previous Period"
            />
          }>
          <IconButton color="primary" onClick={goPrev} size="small">
            <ChevronLeft />
          </IconButton>
        </Tooltip>
      ) : (
        <Box sx={{ width: 40, flexShrink: 0 }} />
      )}
      <Typography variant="subtitle1" fontWeight={600} noWrap>
        {label}
      </Typography>
      <Tooltip
        arrow
        placement="top"
        title={
          <FormattedMessage id="NEXT_PERIOD" defaultMessage="Next Period" />
        }>
        <IconButton color="primary" onClick={goNext} size="small">
          <ChevronRight />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default PeriodNavigator;
